import React from 'react';
import { Button, Typography } from 'components';
import { PrinterOutlined } from '@ant-design/icons';
import { usePackaging } from './usePackaging';
import { ProgressStepper } from '../components/ProgressStepper';
import { OrderIcon } from 'components/common/icons/warehouse/OrderIcon';
import styles from './styles.module.scss';

const { Text, Title } = Typography;

export const Packaging: React.FC = () => {
  const { isLoading, packages, handlePrint, handleDone, handleBack, completedCount, totalCount } = usePackaging();

  if (isLoading) {
    return (
      <div className={styles.container}>
        <div className={styles.loadingContainer}>
          <Text>Loading...</Text>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {/* Progress Stepper */}
      <ProgressStepper
        currentStep={4}
        totalSteps={4}
        completedCount={completedCount}
        totalCount={totalCount}
        onBack={handleBack}
      />

      <div className={styles.content}>
        <div className={styles.header}>
          <Title level={3} className={styles.title}>
            Place Item into the package
          </Title>
          <div className={styles.iconContainer}>
            <OrderIcon />
          </div>
        </div>

        {/* Packages List */}
        <div className={styles.packagesList}>
          {packages.map((pkg: any, index: number) => (
            <div
              key={pkg.id || index}
              className={`${styles.packageCard} ${packages.length > 1 ? styles.withBorder : ''}`}
            >
              <Text className={styles.packageNumber}>Package – {pkg.orderNumber}</Text>
              <Text className={styles.clientInfo}>Client Name - {pkg.clientName}</Text>
              <Text className={styles.itemsInfo}>
                Place <Text strong>{pkg.itemsCount} items</Text> into this package
              </Text>
              <div className={styles.printButtonContainer}>
                <Button
                  type="text"
                  icon={<PrinterOutlined style={{ color: '#05796b', fontSize: '18px' }} />}
                  onClick={() => handlePrint(pkg.id)}
                  className={styles.printButton}
                >
                  <span style={{ color: '#05796b' }}>Print</span>
                </Button>
              </div>
            </div>
          ))}
        </div>

        {/* Empty State */}
        {packages.length === 0 && (
          <div className={styles.emptyState}>
            <Text className={styles.emptyText}>No packages found for this item</Text>
          </div>
        )}
      </div>

      <div className={styles.bottomActions}>
        <Button type="primary" size="large" onClick={handleDone} block>
          Done
        </Button>
      </div>
    </div>
  );
};
